const SingleStats = (statsData) => {



  return (
    <div className="flex flex-col gap-8 mt-8 max-w-[85%] mx-auto pb-32">
      {/* Placeholder Image */}
      <div
        className="w-full h-[300px] lg:h-[550px] bg-cover bg-center rounded-3xl"
        style={{
          backgroundImage: `url(${statsData?.statsData?.image[0]?.original || "/Rectangle.png"})`,
        }}
      />

      {/* Content Paragraph */}
      <p className="text-base lg:text-[1.2rem] font-[500] text-[#667680] leading-[43px] text_small_Bukra text-start" dangerouslySetInnerHTML={{
        __html: statsData?.statsData?.description || "",
      }}>
      </p>
    </div>
  );
};

export default SingleStats;
